"use strict";
var prettyjson_pipe_1 = require("./src/prettyjson.pipe");
exports.PrettyJsonPipe = prettyjson_pipe_1.PrettyJsonPipe;
var json_pipe_1 = require("./src/json.pipe");
exports.SafeJsonPipe = json_pipe_1.SafeJsonPipe;
var prettyjson_component_1 = require("./src/prettyjson.component");
exports.PrettyJsonComponent = prettyjson_component_1.PrettyJsonComponent;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-prettyjson/index.js
// module id = 790
// module chunks = 0